import routes from './routes'

export const isPrivate = true
export { routes }
